'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (InlineCart, $) {
    'use strict';

    var $dom = {};

    var cacheDom = function cacheDom() {
      $dom.inlineCart = $('[data-inline-cart]');
      $dom.lineItemEntryPoint = $('[data-cart-contents]');
    };

    InlineCart.update = function (callback) {
      $.get('/cart?view=contents', function (response) {
        $dom.inlineCart.html(response);
      });
    };

    InlineCart.show = function () {
      $dom.inlineCart.addClass('is-active');
    };

    InlineCart.hide = function () {
      $dom.inlineCart.removeClass('is-active');
    };

    var bindUIActions = function bindUIActions() {};

    InlineCart.init = function () {
      cacheDom();
    };
  })(window.InlineCart = window.InlineCart || {}, _jquery2.default);
};